import BackgroundVideo from '../components/BackgroundVideo';
import { isDesktop } from '../utils';

export default class ModBrandCard {
  constructor(el) {
    this.$el = $(el);
    this.classes = {
      btnPlayPause: 'btn-play-pause',
      videoBrandCard: 'video-brand-card',
    };

    this.dom = {
      $videos: this.$el.find(`.${this.classes.videoBrandCard}`),
      $boxCards: this.$el.find('.box-brand-card'),
      $buttonPlayPause: this.$el.find(`.${this.classes.btnPlayPause}`),
    };

    this.playerVideos = [];
    this.init();
  }

  init() {
    this.getPlayerVideo();
    this.addListeners();
    this.hasImage();
  }

  hasImage() {
    this.dom.$boxCards.each((_index, element) => {
      const $img = $(element).find('.brand-card-item >img');
      if ($img.length) {
        $(element).parent().addClass('has-image');
      }
    });
  }

  addListeners() {
    this.dom.$boxCards.on({
      mouseenter: (event) => {
        this.eventMouseEnterPlayVideo(event);
      },
      mouseleave: (event) => {
        this.eventMouseLeavePauseVideo(event);
      },
    });
  }

  getPlayerVideo() {
    this.dom.$videos.each((index, element) => {
      const player = new BackgroundVideo(element);
      player.init();
      this.playerVideos.push(player);
      $(element).attr('id', `${index}-${player.id}`);
    });
  }

  eventMouseEnterPlayVideo(event) {
    const $elm = $(event.currentTarget);
    const idIframeHovering = $elm.attr('id');

    if ($elm.hasClass(this.classes.videoBrandCard) && isDesktop()) {
      this.playerVideos.forEach((element, index) => {
        const videoItemId = $(element.$el).attr('id');

        if (idIframeHovering === videoItemId) {
          this.playerVideos[index].playVideo();
        }
      });
    }
  }

  eventMouseLeavePauseVideo(event) {
    const $elm = $(event.currentTarget);
    if ($elm.hasClass(this.classes.videoBrandCard) && isDesktop()) {
      this.playerVideos.forEach((element, _index) => {
        element.pauseVideo();
      });
    }
  }
}